import React, { useContext, useEffect, useRef, useState } from "react"
import IdleTimer from "react-idle-timer"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
  CircularProgress
} from "@material-ui/core"
import { CountdownCircleTimer } from "react-countdown-circle-timer"
import { Context } from "../utils/context"
import { authEndPoints } from '../utils/endpoints'
import { flexiaConstants, parseJwt } from '../utils/config'
import useStyles from "../hooks/useStyles"
import { Strings } from '../assets/res/en'

//#region SessionTimerDialog
const SessionTimeoutDialog = ({ open, duration, onLogout, onContinue }) => {
  const classes = useStyles()
  const [clicked, setClicked] = useState(false)
  const handleContinue = (e) => {
    setClicked(true)
    onContinue()
  }
  useEffect(() => {
    return () => {
      setClicked(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Dialog open={open} maxWidth="sm">
      <DialogTitle className={classes.ModalTitle}>{Strings.SESSION_TITLE}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" align="center" color="error">{Strings.SESSION_CONTENT_HEADER}</Typography>
        <Box m={3} />
        <Grid container justify="center" alignItems="center">
          <CountdownCircleTimer
            key={duration}
            size={140}
            strokeWidth={6}
            isPlaying
            duration={duration}
            colors={flexiaConstants.timerIntervalColors}
            onComplete={() => {
              onLogout()
              return [false, 0]
            }}>
            {
              renderTime => (
                <div className={classes.timer}>
                  <div className={classes.timerText}>{Strings.REMAINING}</div>
                  <div className={classes.timerValue}>{renderTime.remainingTime}</div>
                  <div className={classes.timerText}>{Strings.SECONDS}</div>
                </div>
              )
            }
          </CountdownCircleTimer>
        </Grid>
        <Box m={3} />
        <Typography variant="subtitle1" align="center">{Strings.SESSION_CONTENT_FOOTER}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout}
          color="secondary"
          variant="outlined"
          disableElevation
          disabled={clicked}>{Strings.LOGOUT_TITLE}</Button>
        <Button onClick={handleContinue}
          color="primary"
          variant="contained"
          disableElevation
          startIcon={clicked && <CircularProgress size={14} color="inherit" />}
          disabled={clicked}>{Strings.CONTINUE_SESSION}</Button>
      </DialogActions>
    </Dialog>
  )
}
//#endregion

let timeout
let isBusy = false, ispopupVisible = false
let expiryTime
const SessionTimeout = ({ isAuthenticated, logOut }) => {
  const { axios, authData, setAuthData } = useContext(Context)
  const [timeoutModalOpen, setTimeoutModalOpen] = useState(false)
  const [timeoutDuration, setTimeoutDuration] = useState(0)
  const idleTimer = useRef(null)
  useEffect(() => {
    expiryTime = new Date(authData.exp * 1000 - flexiaConstants.sessionTimeoutBuffer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authData])
  useEffect(() => {
    return () => {
      clearSession()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  /// Constantly check token
  useInterval(() => {
    
    const token_status =  onValidateToken()

    switch (token_status) {
      case TOKEN_STATUSES.EXPIRED:
      case TOKEN_STATUSES.NOT_VALID:
        console.log('Token invalid or expired')
        handleLogout(false)
        break;
      case TOKEN_STATUSES.REAUTH:
        console.log('Automatically reauthentication process')
        handleContinue()
        break;
      default:
        //console.log('Session available')
        break;
    }       
  }, 3000)

  const clearSessionTimeout = () => {
    clearTimeout(timeout)
  }
  const clearSession = () => {
    isBusy = false
    ispopupVisible = false
    setTimeoutModalOpen(false)
    clearSessionTimeout()
  }
  const handleLogout = async (isTimedOut = false) => {
    try {
      clearSession()
      logOut()
    } catch (err) {
      console.error(err)
    }
  }
  const handleContinue = () => {
    if (!isBusy) {
      isBusy = true
      axios.post(authEndPoints.refreshToken,
        {
          "token": authData.token,
          "refreshToken": authData.refreshToken
        },
        { headers: { 'Authorization': `Bearer ${authData.token}` } })
        .then(res => {
          if (res.status === 200) {
            const { data } = res.data
            const decodedData = parseJwt(data.token)
            decodedData.context = JSON.parse(decodedData.context)
            setAuthData({
              ...data,
              ...decodedData
            })
          }
          else
            handleLogout()
        })
        .catch(err => console.log(err))
        .finally(() => {
          clearSession()
        })
    }
  }
  const onActive = (event) => !timeoutModalOpen && clearSessionTimeout()
  const onAction = (event) => {
    if (!ispopupVisible) {
      clearSessionTimeout()
      if (new Date() >= expiryTime) handleContinue()
    }
  }
  const onValidateToken = () => {
    const currenttime = new Date().getTime()
    const servertime = (authData.exp * 1000)

    let date = new Date(0)
    date.setUTCSeconds(Math.round(servertime/1000))
    //console.log(`Server:${date.toTimeString()}`)
    //console.log(`Current:${currenttime}`)
    //console.log(`Server:${servertime}`)

    const diff = currenttime - servertime
    if(diff < 0){
        if(diff > -15*60*1000) return TOKEN_STATUSES.REAUTH
        return TOKEN_STATUSES.VALID
    }else{
        return TOKEN_STATUSES.EXPIRED
    }
    
  }

  const TOKEN_STATUSES = {
      VALID:1,
      EXPIRED:2,
      REAUTH:3,
      NOT_VALID:-1
  }
  /*const onIdle = (event) => {
    //console.log('Use is idle')
    const timeNow = new Date().getTime()
    const expTime = expiryTime.getTime()
    const timeDiff = (expTime - timeNow)
    const delay = timeDiff >= flexiaConstants.sessionTimeoutBuffer ? timeDiff : 0
    //console.log(delay)
    if (isAuthenticated && !timeoutModalOpen) {
      timeout = setTimeout(() => {
        let countDown = (Math.min(timeDiff, flexiaConstants.sessionTimeoutBuffer)) / 1000
        setTimeoutModalOpen(true)
        setTimeoutDuration(countDown)
        ispopupVisible = true
      }, delay)
    }
  }*/
  return (
    <>
      {/*<IdleTimer
        ref={idleTimer}
        onActive={onActive}
        //onIdle={onIdle}
        onAction={onAction}
        throttle={1000}
        timeout={5000}
      />*/}
      <SessionTimeoutDialog
        duration={timeoutDuration}
        onContinue={handleContinue}
        onLogout={() => handleLogout(false)}
        open={timeoutModalOpen}
      />
    </>
  )
}
export default SessionTimeout


const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
